// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2PY49","header":"ReportDetails_header__3jXGZ","title":"ReportDetails_title__3rn62","left":"ReportDetails_left__3Duzx"};